import jsPDF from 'jspdf'; // eslint-disable-line import/no-named-as-default
import { applyPlugin } from 'jspdf-autotable';

import { imgData } from 'stocks/components/common/utils/imgPdf';
import { STOCK_ORDERING_PDF_TABLE_ID } from 'stocks/consts';

applyPlugin(jsPDF);

const DEFAULT_ORDER_NUMBER = '00000000001';

// JSpdf Generator For generating the PDF
export const stockOrderingPdfGenerator = (options) => {
  const { salonName, geratedOrderNumber, date, t } = options;
  // eslint-disable-next-line new-cap
  const doc = new jsPDF('p', 'pt');
  const { height } = doc.internal.pageSize;

  doc.addImage(imgData, 'PNG', 426, 35, 115, 68); // x, y, width and height

  doc.setFontSize(12);
  doc.setTextColor('#192340'); // dark blue
  const byOrderText = t('stocks.stockOrderingPdf.byOrderGenerated');
  doc.text(byOrderText, 45, 50); // x, y

  doc.setTextColor(93, 102, 127); // gray text
  doc.text(`${salonName}`, 45 + doc.getTextWidth(byOrderText) + 4, 50);

  doc.setTextColor('#192340');
  const dateLabel = t('stocks.stockOrderingPdf.date');
  doc.text(dateLabel, 45, 74);

  doc.setTextColor(93, 102, 127);
  doc.setFontSize(11);
  doc.text(`${date}`, 45 + doc.getTextWidth(dateLabel) + 4, 74);

  doc.setFontSize(12);
  doc.setTextColor('#192340');
  const uniqueOrderRefText = t('stocks.stockOrderingPdf.uniqueOrderReference');
  doc.text(uniqueOrderRefText, 45, 100);
  const uniqueOrderRefWidth = doc.getTextWidth(uniqueOrderRefText);

  doc.setTextColor(93, 102, 127);
  doc.setFont('courier');
  doc.setFontSize(13);
  doc.text(`${geratedOrderNumber ? geratedOrderNumber : DEFAULT_ORDER_NUMBER}`, 45 + uniqueOrderRefWidth + 4, 100);

  doc.autoTable({
    html: document.getElementById(STOCK_ORDERING_PDF_TABLE_ID),
    startY: 130, //  startY: height, => start on new page
    theme: 'grid', // 'striped', 'grid' or 'plain
    font: 'helvetica', // helvetica, times, courier
    lineWidth: 0.5, // tbl border width
    fontStyle: 'normal', // normal, bold, italic, bolditalic
    headStyles: {
      cellPadding: 6,
      fontSize: 11.5, // px
      fillColor: '#F8EAFF', // brg pink
      textColor: '#192340', // dark blue
      lineColor: '#5D667F', // border
      lineWidth: 0.7, // tbl border width
    },
    styles: {
      cellPadding: 6,
      textColor: [93, 102, 127],
      fillColor: 255, // tbl background
      lineColor: '#5D667F', // tbl border color
    },

    halign: 'left', // left, center, right
    valign: 'middle', // top, middle, bottom
    fillStyle: 'F', // 'S', 'F' or 'DF' (stroke, fill or fill then stroke)
    columnWidth: 'auto', // 'auto', 'wrap' or a number
    didDrawPage(data) {
      doc.setFontSize(10);
      doc.text(' ', 45, height - data.settings.margin.bottom - 10);
    },
  });
  //  doc.autoTable(res.columns, res.data, {
  //    startY: doc.autoTableEndPosY() + 50,
  //  });

  doc.save(t('stocks.stockOrderingPdf.fileName', { salonName, date }));
};
